import { useParams } from "react-router-dom"
import AppRedirectScreen from "../components/AppRedirectScreen"

function ProfileScreen() {
  const { id } = useParams()

  return <AppRedirectScreen type="profile" deepLink={`pepchat://profile/${id}`} />
}

export default ProfileScreen
